import { render, staticRenderFns } from "./areaMainOpportunitySelect.vue?vue&type=template&id=01eb46e8&scoped=true&"
import script from "./areaMainOpportunitySelect.vue?vue&type=script&lang=js&"
export * from "./areaMainOpportunitySelect.vue?vue&type=script&lang=js&"
import style0 from "./areaMainOpportunitySelect.vue?vue&type=style&index=0&id=01eb46e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb46e8",
  null
  
)

export default component.exports